import React from "react";
import InputForm from "../Auth/InputForm";

function ReportForm({ formik }) {
  const handleFormSubmit = () => {
    formik.handleSubmit();
  };
  return (
    <div className="large-form">
      <div className="m-b-b">
        <InputForm
          className="meduim-input transparent-input border p-b border-radius-s "
          name="title"
          type="text"
          placeholder="Subject"
          handleChange={formik.handleChange}
          values={formik.values}
          touched={formik.touched}
          errors={formik.errors}
        />
      </div>

      <div className="m-b-b">
        <InputForm
          className="meduim-input transparent-input border p-extra-b border-radius-s"
          name="desc"
          type="text"
          placeholder="Description"
          handleChange={formik.handleChange}
          values={formik.values}
          touched={formik.touched}
          errors={formik.errors}
        />
      </div>

      <button
        className="btn btn-tomato btn-small m-t-extra-b white btn-center btn-shadow m-t-h"
        type="submit"
        onClick={handleFormSubmit}
      >
        Submit
      </button>
    </div>
  );
}

export default ReportForm;
